<div class="rail-backdrop" *ngIf="openGroup !== null || userFlyoutOpen" (click)="closeFlyoutNow()"></div>

<nav class="rail" aria-label="Primary" (keydown.escape)="closeFlyoutNow()">

  <button type="button" class="rail-logo" (click)="navigate('/overview')"
          aria-label="Go to dashboard">
    <span class="rail-logo-mark">N</span>
  </button>

  <span class="rail-sep" aria-hidden="true"></span>

  <ul class="rail-groups" role="menubar" aria-orientation="vertical">
    <li *ngFor="let section of flatSections; let i = index"
        class="rail-group"
        (mouseenter)="openFlyout(i)"
        (mouseleave)="scheduleClose()">

      <button type="button" class="rail-btn"
              role="menuitem"
              [class.active]="isGroupActive(section)"
              [attr.aria-label]="section.label"
              [attr.aria-haspopup]="true"
              [attr.aria-expanded]="openGroup === i"
              (click)="onRailClick(section, i)"
              (focus)="openFlyout(i)"
              (blur)="scheduleClose()">
        <ng-container *ngTemplateOutlet="ic; context: { name: section.railIcon }"></ng-container>
        <span class="rail-btn-label">{{ section.short }}</span>
      </button>

      <div class="flyout" *ngIf="openGroup === i"
           role="menu" [attr.aria-label]="section.label"
           (mouseenter)="cancelClose()"
           (mouseleave)="scheduleClose()">
        <div class="flyout-head">{{ section.label }}</div>
        <button type="button" class="flyout-item"
                *ngFor="let item of section.items"
                role="menuitem"
                [class.active]="isActive(item.route)"
                (click)="navigate(item.route)">
          <span class="flyout-item-icon">
            <ng-container *ngTemplateOutlet="ic; context: { name: iconFor(item) }"></ng-container>
          </span>
          <span class="flyout-item-label">{{ getDisplayLabel(item) }}</span>
        </button>
      </div>
    </li>
  </ul>

  <div class="rail-user"
       (mouseenter)="openUserFlyout()"
       (mouseleave)="scheduleClose()">
    <button type="button" class="rail-avatar"
            [attr.aria-label]="userName + ' — account menu'"
            [attr.aria-haspopup]="true"
            [attr.aria-expanded]="userFlyoutOpen"
            (click)="onAvatarClick()"
            (focus)="openUserFlyout()"
            (blur)="scheduleClose()">
      <img *ngIf="userPhoto" [src]="userPhoto" class="rail-avatar-img" alt="">
      <span *ngIf="!userPhoto">{{ userInitials }}</span>
    </button>

    <div class="flyout flyout-user" *ngIf="userFlyoutOpen"
         role="menu" aria-label="Account"
         (mouseenter)="cancelClose()"
         (mouseleave)="scheduleClose()">
      <div class="flyout-user-head">
        <div class="flyout-user-av">
          <img *ngIf="userPhoto" [src]="userPhoto" class="flyout-user-av-img" alt="">
          <span *ngIf="!userPhoto">{{ userInitials }}</span>
        </div>
        <div class="flyout-user-meta">
          <span class="flyout-user-name">{{ userName }}</span>
          <span class="flyout-user-role">{{ userRoleLabel }}</span>
        </div>
      </div>
      <button type="button" class="flyout-item" role="menuitem" (click)="navigate('/profile')">
        <span class="flyout-item-icon">
          <ng-container *ngTemplateOutlet="ic; context: { name: 'user' }"></ng-container>
        </span>
        <span class="flyout-item-label">My Profile</span>
      </button>
      <button type="button" class="flyout-item flyout-item-danger" role="menuitem" (click)="logout()">
        <span class="flyout-item-icon">
          <ng-container *ngTemplateOutlet="ic; context: { name: 'log-out' }"></ng-container>
        </span>
        <span class="flyout-item-label">Logout</span>
      </button>
    </div>
  </div>
</nav>

<ng-template #ic let-name="name">
  <svg class="lu" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
       [ngSwitch]="name" aria-hidden="true">
    <ng-container *ngSwitchCase="'home'"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><path d="M9 22V12h6v10"/></ng-container>
    <ng-container *ngSwitchCase="'clock'"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></ng-container>
    <ng-container *ngSwitchCase="'users'"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></ng-container>
    <ng-container *ngSwitchCase="'wallet'"><path d="M19 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5"/><path d="M16 13h.01"/></ng-container>
    <ng-container *ngSwitchCase="'bar-chart'"><line x1="12" y1="20" x2="12" y2="10"/><line x1="18" y1="20" x2="18" y2="4"/><line x1="6" y1="20" x2="6" y2="16"/></ng-container>
    <ng-container *ngSwitchCase="'shield'"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></ng-container>
    <ng-container *ngSwitchCase="'user'"><circle cx="12" cy="8" r="4"/><path d="M4 21v-1a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v1"/></ng-container>
    <ng-container *ngSwitchCase="'layout-dashboard'"><rect x="3" y="3" width="7" height="9" rx="1"/><rect x="14" y="3" width="7" height="5" rx="1"/><rect x="14" y="12" width="7" height="9" rx="1"/><rect x="3" y="16" width="7" height="5" rx="1"/></ng-container>
    <ng-container *ngSwitchCase="'calendar-check'"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/><path d="m9 16 2 2 4-4"/></ng-container>
    <ng-container *ngSwitchCase="'calendar-days'"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/><path d="M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01"/></ng-container>
    <ng-container *ngSwitchCase="'calendar-x'"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/><path d="m14 14-4 4m0-4 4 4"/></ng-container>
    <ng-container *ngSwitchCase="'sun'"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/></ng-container>
    <ng-container *ngSwitchCase="'git-branch'"><line x1="6" y1="3" x2="6" y2="15"/><circle cx="18" cy="6" r="3"/><circle cx="6" cy="18" r="3"/><path d="M18 9a9 9 0 0 1-9 9"/></ng-container>
    <ng-container *ngSwitchCase="'user-plus'"><path d="M14 19v-1a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v1"/><circle cx="8" cy="7" r="4"/><line x1="19" y1="8" x2="19" y2="14"/><line x1="22" y1="11" x2="16" y2="11"/></ng-container>
    <ng-container *ngSwitchCase="'log-out'"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></ng-container>
    <ng-container *ngSwitchCase="'activity'"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></ng-container>
    <ng-container *ngSwitchCase="'package'"><path d="M21 8v8a2 2 0 0 1-1 1.73l-7 4a2 2 0 0 1-2 0l-7-4A2 2 0 0 1 3 16V8a2 2 0 0 1 1-1.73l7-4a2 2 0 0 1 2 0l7 4A2 2 0 0 1 21 8z"/><path d="m3.3 7 8.7 5 8.7-5"/><line x1="12" y1="22" x2="12" y2="12"/></ng-container>
    <ng-container *ngSwitchCase="'banknote'"><rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="12" cy="12" r="2"/><path d="M6 12h.01M18 12h.01"/></ng-container>
    <ng-container *ngSwitchCase="'receipt'"><path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1z"/><path d="M8 7h8M8 11h8M8 15h5"/></ng-container>
    <ng-container *ngSwitchCase="'briefcase'"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></ng-container>
    <ng-container *ngSwitchCase="'settings'"><path d="M20 7h-9"/><path d="M14 17H5"/><circle cx="17" cy="17" r="3"/><circle cx="7" cy="7" r="3"/></ng-container>
    <ng-container *ngSwitchCase="'shield-check'"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></ng-container>
    <ng-container *ngSwitchCase="'file-text'"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/><path d="M9 13h6M9 17h6M9 9h1"/></ng-container>
    <ng-container *ngSwitchCase="'database'"><ellipse cx="12" cy="5" rx="8" ry="3"/><path d="M4 5v6c0 1.66 3.58 3 8 3s8-1.34 8-3V5"/><path d="M4 11v6c0 1.66 3.58 3 8 3s8-1.34 8-3v-6"/></ng-container>
    <ng-container *ngSwitchCase="'history'"><path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/><path d="M12 7v5l3 2"/></ng-container>
    <ng-container *ngSwitchCase="'mail'"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m2 7 10 6 10-6"/></ng-container>
    <ng-container *ngSwitchCase="'map-pin'"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z"/><circle cx="12" cy="10" r="3"/></ng-container>
    <ng-container *ngSwitchCase="'megaphone'"><path d="m3 11 18-5v12L3 14v-3z"/><path d="M11.6 16.8a3 3 0 1 1-5.8-1.6"/></ng-container>
    <circle *ngSwitchDefault cx="12" cy="12" r="9"/>
  </svg>
</ng-template>
